/* qeslint-disable */
// q@ts-nocheck

import { Cartesian3, DeveloperError, Viewer } from "cesium";
import { MouseButton, MouseEvent, MapTool } from "../core";
import { EditablePolygon } from "./annotation/EditablePolygon";

const cart3Scratch = new Cartesian3();

export class PolygonEditTool extends MapTool {
    private _polygon: EditablePolygon | undefined;
    private _selectedPrimitive: any;
    private _nearestVertexIndex: number = -1;
    private _nearestEdgeIndex: number = -1;

    constructor(options: { viewer: Viewer }) {
        super({
            name: "PolygonEditTool",
            viewer: options.viewer
        });
    }

    get polygon() {
        if (!this._polygon) {
            throw new DeveloperError("error");
        }

        return this._polygon;
    }

    activate(activateOptions: { polygon: EditablePolygon }): void {
        super.activate(activateOptions);

        this._polygon = activateOptions.polygon;

        this._polygon.startEditing();
    }

    deactivate(deactivateOptions: { normallyDeactivate: boolean }): void {
        super.deactivate(deactivateOptions);

        if (deactivateOptions && deactivateOptions.normallyDeactivate) {
            this.polygon.restoreMainVertices();
            this.polygon.removeMiddleVertices();
        } else {
            this.polygon.cancelEditing();
        }

        this._polygon = undefined;
    }

    canvasPressEvent(/* event: MouseEvent */): void {
        if (this._nearestVertexIndex === -1 && this._nearestEdgeIndex === -1) {
            this._selectedPrimitive = undefined;

            return;
        }

        if (this._nearestVertexIndex !== -1) {
            this._selectedPrimitive = this.polygon.getMainVertex(this._nearestVertexIndex);
        } else if (this._nearestEdgeIndex !== -1) {
            this._selectedPrimitive = this.polygon.insertMainVertex(this._nearestEdgeIndex);
        }

        if (this._selectedPrimitive) {
            const scene = this._viewer.scene;

            scene.screenSpaceCameraController.enableRotate = false;
        }
    }

    _onMouseMoveForNoExistSelectedPrimitive(event: MouseEvent) {
        const position = this.getWorldPosition(event.pos, cart3Scratch);

        if (!position) {
            return;
        }

        const polygon = this.polygon;

        polygon.hideMiddleVertices();

        const nearestEdgeIndex = polygon.nearestEdgeIndex(position);
        const nearestVertexIndex = polygon.nearestMainVertexIndex(position);
        const contained = polygon.isContainPosition(position);

        this._nearestEdgeIndex = nearestEdgeIndex;
        this._nearestVertexIndex = nearestVertexIndex;

        if (nearestEdgeIndex === -1 && nearestVertexIndex === -1 && !contained) {
            polygon.setOriginalStyleForAllMainVertices();

            return;
        }

        polygon.setGeneralEditingStyleForAllMainVertices();

        if (nearestVertexIndex !== -1) {
            polygon.setVertexEditingStyleForMainVertex(nearestVertexIndex);
        } else if (nearestEdgeIndex !== -1) {
            polygon.showMiddleVertex(nearestEdgeIndex);
        }
    }

    canvasMoveEvent(event: MouseEvent) {
        if (this._selectedPrimitive) {
            if (event.button === MouseButton.LeftButton) {
                this._onDraggingSelectedPointPrimitive(event);
            }
        } else {
            this._onMouseMoveForNoExistSelectedPrimitive(event);
        }
    }

    private _onDraggingSelectedPointPrimitive(event: MouseEvent) {
        const position = this.getWorldPosition(event.pos, cart3Scratch);

        if (!position) {
            return;
        }

        if (!this._selectedPrimitive) {
            throw new DeveloperError("error");
        }

        const index = this.polygon.indexOfMainVertices(this._selectedPrimitive);

        if (index !== -1) {
            this.polygon.updateMainVertex(index, position);
        }
    }

    canvasReleaseEvent(/* event: MouseEvent */): void {
        if (this._selectedPrimitive) {
            this.polygon.updateTurfPolygon();
        }

        this._selectedPrimitive = undefined;

        const scene = this._viewer.scene;

        scene.screenSpaceCameraController.enableRotate = true;
    }

    canvasDoubleClickEvent(event: MouseEvent): void {
        if (this._polygon!.polygonPrimitive.positions.length < 4) {
            return;
        }

        const position = this.getWorldPosition(event.pos, cart3Scratch);

        if (!position) {
            return;
        }

        const nearestVertexIndex = this.polygon.nearestMainVertexIndex(position);

        if (nearestVertexIndex === -1) {
            return;
        }

        this.polygon.removeMainVertex(nearestVertexIndex);
    }
}
